import classNames from 'classnames';
import styles from './divider.module.css';

export function Divider({ largePadding }: { largePadding?: boolean }) {
    return (
        // eslint-disable-next-line @typescript-eslint/dot-notation
        <div className={classNames(styles['divider'], { [styles['divider__large']]: largePadding })} />
    );
}
